<template>
  <div
    class="flex flex-col px-10 md:px-0 pt-24 md:pl-140px lg:pl-200px h-screen"
  >
    <div class="text-30px md:text-70px text-qwray font-Foco md:mt-24 font-bold">
      {{ $t('meter.big_header') }}
    </div>
    <div
      class="bg-red-100 border border-qwray text-qwray px-4 py-3 rounded relative w-300px md:w-600px text-20px"
      :class="al ? '' : 'hidden'"
      role="alert"
    >
      <span class="block">{{ $t('meter.not_found') }}</span>
      <span
        class="absolute top-0 bottom-0 right-0 px-4 py-4"
        v-on:click="onAlertClose"
      >
        <svg
          class="fill-current h-6 w-6 text-red-500"
          role="button"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <title>Close</title>
          <path
            d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
          />
        </svg>
      </span>
    </div>
    <div
      class="flex flex-col text-14px mt-4 md:text-20px text-qwray h-full"
      :class="found ? '' : 'hidden'"
    >
      <div class="flex">
        <div>{{ $t('meter.session_id_label') }}:</div>
        <div class="ml-2">{{ sessionId }}</div>
      </div>
      <div class="flex mt-2">
        <div>{{ $t('meter.date_label') }}:</div>
        <div class="ml-2">{{ date }}</div>
      </div>
      <div class="flex mt-2">
        <div>{{ $t('meter.address_label') }}:</div>
        <div class="ml-2">{{ address }}</div>
      </div>
      <div class="mt-auto md:mt-0 mb-8 font-Foco">
        <button
          class="bg-qwellow text-16px text-qwray border-qwray rounded-full text-sm py-3 px-24 rounded md:mt-10 w-auto mt-auto mb-10 font-bold"
          type="button"
          v-on:click="onClick($event)"
        >
          {{ $t('meter.submit_button') }}
        </button>
        <div class="text-14px md:text-16px pl-6 underline">
          <a href="https://www.safe-ev.de/de/transparenzsoftware.php">{{
            $t('meter.transparenz_software')
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sessionId: '',
      date: '',
      address: '',
      al: false,
      found: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        const response = await fetch(
          // eslint-disable-next-line
          `${process.env.VUE_APP_BACKEND_URL}/meter/${this.$route.params.id}/`
        );
        if (response.status !== 200) {
          this.found = false;
          this.al = true;
        } else {
          const data = await response.json();
          this.sessionId = this.$route.params.id;
          this.address = data.data.chargePointAddress;
          this.date = new Date(data.data.startedAt).toLocaleDateString();
          this.found = true;
        }
      } catch (err) {
        this.al = true;
      }
    },
    async onClick($event) {
      try {
        $event.preventDefault();
        const response = await fetch(
          // eslint-disable-next-line
          `${process.env.VUE_APP_BACKEND_URL}/meter/${this.$route.params.id}/xml`
        );
        if (response.status !== 200) {
          this.al = true;
        } else {
          const content = await response.blob(); // download as Blob object
          const blob = new Blob([content], {
            type: 'application/xml',
          });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${this.$route.params.id}.xml`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (err) {
        this.al = true;
      }
    },
    onAlertClose() {
      this.al = false;
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
};
</script>
